<template>
    <v-container>
      <v-lazy v-for="i in numberRows" :key="i + '-i'"
              v-model="isActive[i]"
              :options="{ threshold: .5 }"
              min-height="50"
              transition="fade-transition"
      >
        <v-row class="text-center justify-center">
            <v-col v-for="j in numCols" :key="j + '-j'" 
                   :cols="getBoundIdx(i, j) >= projectCount ? 0 : 12" 
                   :lg="12 / numCols" 
                   :xl="12 / numCols" 
                   :style="{height: getBoundIdx(i, j) >= projectCount ? '0rem' : '18rem'}"
            >
              <PortfolioCard v-if="getBoundIdx(i, j) < projectCount" :key="projects[getBoundIdx(i, j)].title" :project="projects[getBoundIdx(i, j)]" />
            </v-col>
        </v-row>
      </v-lazy>
    </v-container>
</template>

<script>
  import PortfolioCard from './PortfolioCard';
  import projects from '@/data/projects';

  export default {
    name: 'Portfolio',
    components: {
      PortfolioCard,
    },
    data: () => ({
        projects: projects,
        projectCount: projects.length,
        numberRows: Math.ceil(projects.length / 3),
        isActive: [],
        numCols: 3,
    }),
    mounted() {
      for (let i = 0; i < this.numberRows; i++)
        this.isActive.push(false);
    },
    methods: {
      getBoundIdx(i, j) {
        return (3 * (i - 1)) + (j - 1);
      }
    }
  }
</script>

<style type="scss" scoped>

@media screen and (max-width: 615px) {
  .card-padding {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

</style>
